import {
    Stack,
    Text,
    Title
} from "@mantine/core";

import {FieldArray} from "formik";

import {
    ListRowElement,
    PacFormikListProps
} from "./types";

import {AddRowButton} from "./AddRowButton";
import {ListRows} from "./ListRows";


export const FormikList = ({
                               field,
                               label,
                               description,
                               getRowElements,
                           }: PacFormikListProps) => {


    return (
        <Stack gap={'xs'}>
            <Title order={5}>{label}</Title>
            <Text c={'dimmed'}>{description}</Text>
            <FieldArray name={field.name}>
                {
                    (
                        {
                            remove,
                            push
                        }
                    ) => {

                        // build empty row object
                        const reducer = (result: Record<string, string>, element: { name: string }) => {
                            result[element.name] = "";
                            return result;
                        };

                        const rowElements: ListRowElement[] = getRowElements();
                        const emptyRow = rowElements.reduce(reducer, {});

                        return (
                            <Stack>
                                <ListRows
                                    fieldName={field.name}
                                    remove={remove}
                                    getRowElements={getRowElements}
                                />

                                <AddRowButton
                                    push={push}
                                    row={emptyRow}
                                />


                            </Stack>
                        )
                    }
                }
            </FieldArray>
        </Stack>
    );
};

